import { z } from "zod";

// F-PPL-01b — farklı kayıt kimlikleri karışmasın; hedefin türünü sunucu ilişkilerden doğrular.
export const davetYenidenGonderSemasi = z.union([
  z.object({ kullaniciId: z.string().min(1).max(64) }).strict(),
  z.object({ ogrenciId: z.string().min(1).max(64) }).strict(),
  z.object({ veliBagId: z.string().min(1).max(64) }).strict(),
]);
export type DavetYenidenGonderIstegi = z.infer<typeof davetYenidenGonderSemasi>;
export const davetYenidenGonderSonucSemasi = z.object({ davetGonderildi: z.boolean() });
export const davetDurumuSemasi = z.object({ davetBekliyor: z.boolean() });
export type HesapDavetDurumu = z.infer<typeof davetDurumuSemasi>;

// F-MNT-03 — öğrenci dosyası koçsuz hesabın düğmesini öğrenci oluşturma iznine bağlamamalı.
export const ogrenciDavetDurumuSemasi = davetDurumuSemasi.extend({
  davetIzni: z.enum(["kisi.ogrenci.olustur", "mentorum.erisim.yonet"]),
});
export type OgrenciDavetDurumu = z.infer<typeof ogrenciDavetDurumuSemasi>;
